<div class="fraction-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt bar with the big fraction -->
  <div class="prompt-bar">
    <span class="prompt-text">
      {{ currLang === 'ar' ? 'أطلق الصاروخ إلى' : 'Blast the rocket to' }}
    </span>
    <span class="fraction" aria-hidden="false">
      <span class="num">{{ round.numerator }}</span>
      <span class="bar"></span>
      <span class="den">{{ round.denominator }}</span>
    </span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-fraction-line-stage
      [round]="round"
      [roundKey]="currentRound"
      [hintVisible]="hintVisible"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-fraction-line-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn hint-btn" *ngIf="canUseHint" (click)="useHint()">
      <span aria-hidden="true">💡</span>
      {{ currLang === 'ar' ? 'تلميح' : 'Hint' }}
    </button>

    <button class="ctrl-btn launch-btn" [disabled]="resolving || firing" (click)="onLaunch()">
      <span aria-hidden="true">🚀</span>
      {{ currLang === 'ar' ? 'إطلاق' : 'LAUNCH' }}
    </button>

    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Success burst -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <div class="success-icon" aria-hidden="true">🚀</div>
      <div class="success-title">{{ currLang === 'ar' ? 'إصابة موفّقة!' : 'Direct hit!' }}</div>
      <div class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</div>
    </div>
  </div>


  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
